import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import MetaTitle from '../../../src/common/component/MetaTitle';
import {IS_CLIENT} from '../../../src/common/constant';
import {Page} from '../../../src/common/constant/page';
import {getMetaTitle} from '../../../src/common/function';
import useBlockContextMenu from '../../../src/common/hook/useBlockContextMenu';
import useTypedSelector from '../../../src/common/hook/useTypedSelector';
import {IKwPage} from '../../../src/common/type';
import {redirectTo} from '../../../src/common/util/PageRouter';
import Viewer from '../../../src/viewer/container/Viewer';
import useWaterMark from '../../../src/viewer/hook/useWaterMark';
import {actions} from '../../../src/viewer/state/actions';

interface IProps {
  episodeId: number;
  prevPage: Page;
  isSsr: boolean;
}

interface IQuery {
  id: string;
  sid: string;
}

const ViewerPage: IKwPage<IProps, IQuery> = ({
  episodeId,
  prevPage,
  isSsr,
}: IProps) => {
  const dispatch = useDispatch();
  const [episode, content] = useTypedSelector(state => [
    state.viewer.episode,
    state.viewer.content,
  ]);

  useBlockContextMenu();
  useWaterMark();

  useEffect(() => {
    return () => {
      dispatch(actions.setValue('isRunMode', false));
    };
  }, [dispatch]);

  const title =
    episode && content ? `${content?.title} - ${episode?.title}` : '';
  return (
    <>
      <MetaTitle page={Page.Viewer} title={getMetaTitle(title)} />
      <Viewer
        key={episodeId}
        episodeId={episodeId}
        prevPage={prevPage}
        isSsr={isSsr}
      />
    </>
  );
};

ViewerPage.initialPageProps = {
  page: Page.Viewer,
  getPageTitle: () => '',
};

ViewerPage.getInitialProps = ({query, store, res, req}) => {
  const episodeId = Number(query.id);

  if (isNaN(episodeId)) {
    redirectTo({pageInfo: '/404', res});
    return {} as any;
  }

  store.dispatch(
    actions.fetchViewerEpisode({
      episodeId,
      sid: query.sid,
      res,
      req,
    })
  );

  return {
    episodeId,
    prevPage: store.getState().common.layoutProps.page,
    isSsr: !IS_CLIENT,
  };
};

export default ViewerPage;
